var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui centered grid"},[_c('div',{staticClass:"four wide column"}),_vm._v(" "),_c('div',{staticClass:"eight wide column"},[_c('TheNoteList',{attrs:{"all_notes_view":true,"primary_item":""}})],1),_vm._v(" "),_c('div',{staticClass:"four wide column"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff216c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/notes.vue
// module id = null
// module chunks = 